import BrowserHistoryManager from "@web/vpt-assets/assets/js/utilities/dom/browserHistoryManager";

export default class BookGoBackManager
{
    constructor(modalIdGoBack) {
        this.modalId = modalIdGoBack;
        if (!this.modalId) return;

        this.eventDelegation();
    }

    eventDelegation()
    {
        let modal = $(this.modalId);
        if (modal.length === 0) {
            return;
        }

        myApp.browserHistoryManager.addState(this.modalId);
        modal.on('pop-state', () => {
            if(!modal.is(':visible')) {
                myApp.customModalManager.openModal(this.modalId)
            } else {
                myApp.browserHistoryManager.addState(this.modalId);
            }
        });
    }
}
